var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cart",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16667 15.1087C5.16667 14.3403 5.76362 13.7174 6.5 13.7174C7.23638 13.7174 7.83333 14.3403 7.83333 15.1087C7.83333 15.8771 7.23638 16.5 6.5 16.5C5.76362 16.5 5.16667 15.8771 5.16667 15.1087Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 15.1087C12.5 14.3403 13.0969 13.7174 13.8333 13.7174C14.5697 13.7174 15.1667 14.3403 15.1667 15.1087C15.1667 15.8771 14.5697 16.5 13.8333 16.5C13.0969 16.5 12.5 15.8771 12.5 15.1087Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 1.19565C0.5 0.811454 0.798477 0.5 1.16667 0.5H3.83333C4.15108 0.5 4.42467 0.734007 4.48703 1.05913L5.04695 3.97826H15.8333C16.032 3.97826 16.2203 4.07073 16.347 4.23047C16.4736 4.39021 16.5254 4.60058 16.4882 4.80423L15.4206 10.646C15.3291 11.1264 15.0786 11.5579 14.713 11.8651C14.3492 12.1707 13.8944 12.3337 13.4276 12.3261H6.95905C6.49222 12.3337 6.03746 12.1707 5.67365 11.8651C5.30819 11.5581 5.05779 11.1268 4.96624 10.6467L4.96611 10.646L3.85253 4.84031C3.84801 4.82111 3.84425 4.80159 3.8413 4.78179L3.28688 1.8913H1.16667C0.798477 1.8913 0.5 1.57985 0.5 1.19565ZM5.31382 5.36957L6.27389 10.3749C6.30437 10.535 6.38786 10.6789 6.50974 10.7813C6.63162 10.8837 6.78412 10.938 6.94056 10.9349L6.95333 10.9348H13.4333L13.4461 10.9349C13.6025 10.938 13.755 10.8837 13.8769 10.7813C13.9982 10.6794 14.0815 10.5364 14.1123 10.3771L15.0275 5.36957H5.31382Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.a00ad6c70898d87fea2ac4b306df6dfe.svg";
export { ForwardRef as ReactComponent };